module.exports = __webpack_public_path__ + "static/media/male_1.a39941e5.png";